import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { BaseFormComponent } from 'projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component';
import { SelectorService } from 'projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service';
import { Lookup } from 'projects/sepidz-web-framework/src/lib/models';
import { HttpCommonService } from 'projects/sepidz-web-framework/src/lib/services';
import { takeUntil } from 'rxjs/operators';
import { OrderService } from 'src/app/frontoffice/order/order.service';
import { PrintTemplate } from 'src/app/frontoffice/prints/model/print-template.model';

@Component({
  selector: 'app-customer-print-template-form',
  templateUrl: './customer-print-template-form.component.html',
  styleUrls: ['./customer-print-template-form.component.scss']
})
export class CustomerPrintTemplateFormComponent extends BaseFormComponent<PrintTemplate> {
  otherCustomerPrintTemplates: Lookup[] = [];
  order: OrderService;
  deactivateSave: boolean = false;
  constructor(protected selectorService: SelectorService,
    protected cd: ChangeDetectorRef,
    public httpCommonService: HttpCommonService) {
    super(selectorService, cd);
  }
  async ngOnInit() {
    this.fillData();
    this.fillOtherCustomerPrintTemplates();
  }
  submitButtonDisabled(): boolean {
    if (!this.formGroup.controls['otherPrintTempplateId'].value) {
      this.isSaved = false;
      return true;
    }
    else {
      this.isSaved = true;
      return false;
    }
  }
  valueChanges() {
    this.submitButtonDisabled();
  }
  fillOtherCustomerPrintTemplates() {
    this.httpCommonService.getItem("PrintTemplate/ReadValidCustomerPrintTemplates", this.order.saleMethodBranch.Id)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((data: any[]) => {
        this.otherCustomerPrintTemplates = data;
      });
  }
  fillData() {
    const newGroup: any = {};
    newGroup['otherPrintTempplateId'] = new UntypedFormControl(undefined);
    this.formGroup = new UntypedFormGroup(newGroup);
  }
  async save() {
    if (this.submitButtonDisabled())
      return;
    this.result = this.formGroup.controls['otherPrintTempplateId'].value;
    this.close();
  }

}
